/* WKOŁO – baner z książkami (sekcja wkolo-baner).
   Klik w boczną książkę, kropkę albo strzałkę przesuwa książkę na środek; klik w środkową to zwykły link.
   Automatyczna zmiana co data-autoplay sekund (0 = wyłączona), pauza po najechaniu myszką i przy fokusie. */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (!root || root.__wkBaner) return;
    root.__wkBaner = true;
    var books = Array.prototype.slice.call(root.querySelectorAll('.wk-baner__book'));
    var texts = Array.prototype.slice.call(root.querySelectorAll('.wk-baner__text'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.wk-baner__dot'));
    var n = books.length;
    if (n < 2) return;
    var delay = (parseInt(root.getAttribute('data-autoplay'), 10) || 0) * 1000;
    var cur = 0, timer, hold = false;

    function render() {
      var t = texts[cur];
      if (t) {
        root.style.setProperty('--bg', t.getAttribute('data-bg'));
        root.style.setProperty('--fg', t.getAttribute('data-fg'));
        root.style.setProperty('--ac', t.getAttribute('data-ac'));
      }
      books.forEach(function (b, i) {
        var p = (i - cur + n) % n;
        if (p > n / 2) p -= n;                       // 3 książki: 0 środek, 1 prawa, -1 lewa
        b.setAttribute('data-pos', Math.abs(p) > 1 ? 'hide' : p);
        b.tabIndex = p === 0 ? 0 : -1;
      });
      texts.forEach(function (x, i) {
        var on = i === cur;
        x.classList.toggle('is-active', on);
        if (on) x.removeAttribute('aria-hidden'); else x.setAttribute('aria-hidden', 'true');
        var cta = x.querySelector('.wk-baner__cta');
        if (cta) cta.tabIndex = on ? 0 : -1;
      });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === cur); d.setAttribute('aria-current', i === cur ? 'true' : 'false'); });
    }

    function schedule() {
      clearTimeout(timer);
      if (!REDUCED && delay > 0 && !hold) timer = setTimeout(function () { go(cur + 1); }, delay);
    }

    function go(i) {
      cur = (i % n + n) % n;
      render();
      schedule();
    }

    root.addEventListener('click', function (e) {
      var b = e.target.closest('.wk-baner__book');
      if (b && b.getAttribute('data-pos') !== '0') { e.preventDefault(); go(+b.getAttribute('data-i')); return; }
      var d = e.target.closest('[data-go]');
      if (d) { go(+d.getAttribute('data-go')); return; }
      var s = e.target.closest('[data-step]');
      if (s) go(cur + +s.getAttribute('data-step'));
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') go(cur - 1);
      if (e.key === 'ArrowRight') go(cur + 1);
    });
    root.addEventListener('mouseenter', function () { hold = true; clearTimeout(timer); });
    root.addEventListener('mouseleave', function () { hold = false; schedule(); });
    root.addEventListener('focusin', function () { hold = true; clearTimeout(timer); });
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) { hold = false; schedule(); } });

    // przesuwanie palcem na telefonie
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1));
      x0 = null;
    });

    render();
    schedule();
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('.wk-baner'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
